import { debounce } from 'lodash';

export default {
  data() {
    const data = {
      department: null,
      departments: [],
    };
    data.departments.allDepartmentsItem = { ID: null, Name: 'All Departments', Number: 'All Departments' };
    data.departments.default = data.departments.allDepartmentsItem;
    data.departments.byId = {};
    return data;
  },
  methods: {
    getDepartments(withAll = false) {
      return withAll ? [this.departments.allDepartmentsItem, ...this.departments] : this.departments;
    },
    async fetchDepartments() {
      this.$startLoading('departments');

      const departments = await this.$api.departments.index();
      departments.allDepartmentsItem = this.departments.allDepartmentsItem;
      departments.default = this.departments.default;
      departments.byId = departments.reduce((acc, department) => ({ ...acc, [department.ID]: department }), {});
      this.departments = departments;

      if (!this.department) {
        if (this.$cookies.isKey('lastSelectedDepartmentID')) {
          const lastSelectedDepartmentID = parseInt(this.$cookies.get('lastSelectedDepartmentID'), 10);
          this.department = this.departments.find(({ ID }) => ID === lastSelectedDepartmentID);
        }
        if (!this.department) {
          this.setDepartment(this.getDefaultDepartment());
        }
      }
      this.$stopLoading('departments');
      return this.departments;
    },
    getDepartment(field) {
      if (!this.department) {
        return undefined;
      }
      return field ? this.department[field] : this.department;
    },
    getDepartmentBy(field, value) {
      return field === 'ID' ? this.departments.byId[value] : this.departments.find(department => department[field] === value);
    },
    setDepartmentDebounce(department) {
      if (department !== this.department) {
        this.$startLoading('departments');
        this._setDepartmentDebounce(department);
      }
    },
    _setDepartmentDebounce: debounce(function setDepartmentDebounce(department) {
      this.setDepartment(department);
      this.$stopLoading('departments');
    }, 200),
    setDepartment(department) {
      if (typeof department === 'number') {
        this.department = this.departments[department];
      } else {
        this.department = department;
      }
    },
    setAllDepartmentsItem(name, number) {
      this.departments.allDepartmentsItem.Name = name;
      this.departments.allDepartmentsItem.Number = number;
    },
    getDefaultDepartment() {
      return this.departments.default;
    },
    setDefaultDepartment(department) {
      this.departments.default = department;
    },
  },
  watch: {
    department() {
      if (this.department) {
        if (this.department.ID) {
          this.$cookies.set('lastSelectedDepartmentID', this.department.ID, '1y');
        }
      } else {
        this.$nextTick(() => {
          this.setDepartment(this.getDefaultDepartment());
        });
      }
    },
  },
};
